import tw, { styled } from 'twin.macro';

export const SectionWrapper = styled.div(() => [
  tw`
    mb-10
  `,
]);
